
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ValidationUtils } from 'src/app/shared/utils/validation.utils';
import { FindAllNoiseCatalogNumberListRequest } from '../../core/models/findAllNoiseCatalogNumberListRequest';
import { FindAllNoiseCatalogNumberListResponse } from '../../core/models/findAllNoiseCatalogNumberListResponse';
import { FindOneNoiseCatalogNumberRequest } from '../../core/models/findOneNoiseCatalogNumberRequest';
import { FindOneNoiseCatalogNumberResponse } from '../../core/models/findOneNoiseCatalogNumberResponse';
import { NoiseCatalogFilterRequest } from '../../core/models/noiseCatalogFilterRequest';
import { NoiseCatalogFilterResponse } from '../../core/models/noiseCatalogFilterResponse';
import { NoiseCatalogParamsRefDataResponse } from '../../core/models/noiseCatalogParamsRefDataResponse';
import { ResultStatus } from '../../core/models/resultStatus';
import { SolrSanitizer } from '../../shared/solr-sanitizer.util';
// import {Observable} from 'rxjs';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    //'Authorization': environment.authorization
  }),

};
@Injectable()
export class NoiseCatalogService implements OnInit {
  private noiseCatalogAPIUrl: string;
  private noiseCatalogParamsRefDataResponse = new BehaviorSubject<NoiseCatalogParamsRefDataResponse | null>(null);
  private findAllNoiseCatalogNumberListResponse = new BehaviorSubject<FindAllNoiseCatalogNumberListResponse | null>(null);
  private findOneNoiseCatalogNumberResponse = new BehaviorSubject<FindOneNoiseCatalogNumberResponse | null>(null);
  private noiseCatalogFilterResponse = new BehaviorSubject<NoiseCatalogFilterResponse | null>(null);
  private endpointURL_noiseCatalog = 'noiseCatalog/all';
  private endpointURL_noisecatalog_search_by_filter = 'solr-search/noiseCatalogAll'

  // private endpointURL_videos = 'video/all';
  // private endpointURL_channels = 'channel/all';
  private endpointURL_noiseCatalogs_by_maingroup = 'noiseCatalog/mainGroup/';

  constructor(private http: HttpClient) {
    //this.noiseCatalogAPIUrl = environment.noiseCatalogAPIUrl;
  }

  ngOnInit() {
    //this.noiseCatalogAPIUrl = environment.noiseCatalogAPIUrl;
  }
  getNoiseCatalogDataByFilter(noiseCatalogFilterRequest: NoiseCatalogFilterRequest): Observable<any> {

    const url = this.endpointURL_noisecatalog_search_by_filter;
    let paramsNoiseCatalogFilter = new HttpParams();
    if (!((noiseCatalogFilterRequest.mainGroup === null || noiseCatalogFilterRequest.mainGroup === undefined))) {
      paramsNoiseCatalogFilter = paramsNoiseCatalogFilter.append('mainGroup', SolrSanitizer.sanitizeFilterValue(noiseCatalogFilterRequest.mainGroup));
    }
    if (!((noiseCatalogFilterRequest.sporadicOrPermanent === null || noiseCatalogFilterRequest.sporadicOrPermanent === undefined))) {
      paramsNoiseCatalogFilter = paramsNoiseCatalogFilter.append('sporadicOrPermanent', SolrSanitizer.sanitizeFilterValue(noiseCatalogFilterRequest.sporadicOrPermanent));
    }
    if (!((noiseCatalogFilterRequest.areaFilterList === null || noiseCatalogFilterRequest.areaFilterList === undefined))) {
      const sanitizedAreaList = noiseCatalogFilterRequest.areaFilterList.map(area => SolrSanitizer.sanitizeFilterValue(area)).join(',').replace(/,\s*$/, "");
      paramsNoiseCatalogFilter = paramsNoiseCatalogFilter.append('areaList', sanitizedAreaList);
    }
    if (!((noiseCatalogFilterRequest.componentFilterList === null || noiseCatalogFilterRequest.componentFilterList === undefined))) {
      const sanitizedComponentList = noiseCatalogFilterRequest.componentFilterList.map(component => SolrSanitizer.sanitizeFilterValue(component)).join(',').replace(/,\s*$/, "");
      paramsNoiseCatalogFilter = paramsNoiseCatalogFilter.append('componentList', sanitizedComponentList);
    }
    if (!((noiseCatalogFilterRequest.drivingConditionFilterList === null || noiseCatalogFilterRequest.drivingConditionFilterList === undefined))) {
      const sanitizedDrivingCondList = noiseCatalogFilterRequest.drivingConditionFilterList.map(cond => SolrSanitizer.sanitizeFilterValue(cond)).join(',').replace(/,\s*$/, "");
      paramsNoiseCatalogFilter = paramsNoiseCatalogFilter.append('drivCondList', sanitizedDrivingCondList);
    }
    if (!((noiseCatalogFilterRequest.weatherConditionFilterList === null || noiseCatalogFilterRequest.weatherConditionFilterList === undefined))) {
      const sanitizedWeatherCondList = noiseCatalogFilterRequest.weatherConditionFilterList.map(cond => SolrSanitizer.sanitizeFilterValue(cond)).join(',').replace(/,\s*$/, "");
      paramsNoiseCatalogFilter = paramsNoiseCatalogFilter.append('weatherCondList', sanitizedWeatherCondList);
    }
    if (!((noiseCatalogFilterRequest.kindOfNoiseFilterList === null || noiseCatalogFilterRequest.kindOfNoiseFilterList === undefined))) {
      const sanitizedNoiseTypesList = noiseCatalogFilterRequest.kindOfNoiseFilterList.map(type => SolrSanitizer.sanitizeFilterValue(type)).join(',').replace(/,\s*$/, "");
      paramsNoiseCatalogFilter = paramsNoiseCatalogFilter.append('noiseTypesList', sanitizedNoiseTypesList);
    }
    if (!((noiseCatalogFilterRequest.seriesFilterList === null || noiseCatalogFilterRequest.seriesFilterList === undefined))) {
      const sanitizedSeriesList = noiseCatalogFilterRequest.seriesFilterList.map(series => SolrSanitizer.sanitizeFilterValue(series)).join(',').replace(/,\s*$/, "");
      paramsNoiseCatalogFilter = paramsNoiseCatalogFilter.append('seriesList', sanitizedSeriesList);
    }
    const httpOptionsParams = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        //'Authorization': environment.authorization
      }),
      params: paramsNoiseCatalogFilter
    };
    return this.http.get(url, httpOptionsParams)
      .pipe(
        tap(data => this.noiseCatalogFilterResponse.next(data)),
        catchError(err => this.handleHttpError(err))
      );
  }

  // get all noise catalog
  getNoiseCatalogData(): Observable<any> {
    return this.http.get(this.endpointURL_noiseCatalog, { withCredentials: true });
  }
  // save user's watchlist sort order
  saveWatchlistSortOrder(userId, noisecatalogList) {
    return this.http.post(`user-info/qID/${userId}/updateAllSortedNoiseCatalogWatchlist`, noisecatalogList, { withCredentials: true });
  }
  // increment user likes
  posttNoiseCatalogLikes(userId, noisecatalogId): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/addNoiseCatalogToLikelist/${noisecatalogId}`, '', { withCredentials: true });
  }
  // increment user dislikes
  posttNoiseCatalogDislikes(userId, noisecatalogId): Observable<any> {
    return this.http.post(`user-info/qID/${userId}/addNoiseCatalogToDislikelist/${noisecatalogId}`, '', { withCredentials: true });
  }
  // increment views of noisecatalog by user
  postNoiseCatalogViews(userId, noisecatalogId) {
    const sanitizedUserId = ValidationUtils.sanitizeQID(userId);
    const sanitizedNoisecatalogId = ValidationUtils.sanitizeQID(noisecatalogId);
    return this.http.post(`user-info/qID/${sanitizedUserId}/addNoiseCatalogToViewlist/${sanitizedNoisecatalogId}`, '', { withCredentials: true });
  }
  // get user history of noise catalog
  getUserWatchHistory(userId) {
    return this.http.get(`user-info/qID/${userId}/noiseCatalogHistorylist`, { withCredentials: true });
  }

  // get noisecatalog like/dislike status
  getUserNoiseCatalogLikesDislikes(userId, noisecatalogId) {
    return this.http.get(`user-info/qID/${userId}/findNoiseCatalogLikedOrDisliked/${noisecatalogId}`, { withCredentials: true });
  }
  // remove noise catalog from user's watchlist
  removeNoiseCatalogFromWatchlist(userId, noisecatalogId) {
    return this.http.post(`user-info/qID/${userId}/removeNoiseCatalogFromWatchlist/${noisecatalogId}`, '', { withCredentials: true });
  }
  // get list user watchlisted NoiseCatalog
  getUsersWatchlist(userId) {
    return this.http.get(`user-info/qID/${userId}/noiseCatalogueWatchlist`, { withCredentials: true });
  }
  // add noise catalog from watchlist by user
  addNoiseCatalogToWatchlist(userId, noisecatalogId) {
    return this.http.post(`user-info/qID/${userId}/addNoiseCatalogToWatchlist/${noisecatalogId}`, '');
  }

  // get videos with channel id
  getNoiseCatalogsFromMaingroup(maingroupNumber): Observable<any> {
    return this.http.get(this.endpointURL_noiseCatalogs_by_maingroup + maingroupNumber, { withCredentials: true });
  }

  // add/remove video from watchlist by user
  toggleNoiseCatalogWatchlist(userId, noisecatalogId) {
    return this.http.post(`user-info/qID/${userId}/toggleNoiseCatalogWatchlist/${noisecatalogId}`, '', { withCredentials: true });
  }
  findAllNoiseCatalogParamsRefData(): Observable<NoiseCatalogParamsRefDataResponse | ResultStatus> {
    //const url = `${this.noiseCatalogAPIUrl}` + `/` + `tisParam/findAllNoiseCatalogParamsRefData`;
    const url = `tisParam/findAllNoiseCatalogParamsRefData`;
    // return of(sampleNoiseCatalogParamsRefData);
    return this.http.get<NoiseCatalogParamsRefDataResponse>(url, httpOptions)
      .pipe(
        tap(data => this.noiseCatalogParamsRefDataResponse.next(data)),
        catchError(err => this.handleHttpError(err))
      );
  }

  findAllNoiseCatalogNumberList(findAllNoiseCatalogNumberListRequest: FindAllNoiseCatalogNumberListRequest): Observable<FindAllNoiseCatalogNumberListResponse | ResultStatus> {
    const url = `noiseCatalog/findAllNoiseCatalogNumberList`;
    let paramsMakeName = new HttpParams();
    paramsMakeName = paramsMakeName.append('makeName', findAllNoiseCatalogNumberListRequest.makeName);
    // return of(sampleNoiseCatalogParamsRefData);

    const httpOptionsParams = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',

      }),
      params: paramsMakeName
    };
    return this.http.get<FindAllNoiseCatalogNumberListResponse>(url, httpOptionsParams)
      .pipe(
        tap(data => this.findAllNoiseCatalogNumberListResponse.next(data)),
        catchError(err => this.handleHttpError(err))
      );
  }

  // getNoiseCatalogInfo(docNumber, makeName): Observable<any> {
  //   return this.http.get(`noiseCatalog/findOneNoiseCatalogNumber/${docNumber}?makeName=${makeName}`);
  // }

  findOneNoiseCatalogNumber(findOneNoiseCatalogNumberRequest: FindOneNoiseCatalogNumberRequest): Observable<FindOneNoiseCatalogNumberResponse | ResultStatus> {
    //const url = `noiseCatalog/findOneNoiseCatalogNumber`;
    const url = `noiseCatalog/findOneNoiseCatalogNumber/` + findOneNoiseCatalogNumberRequest.docNumber;
    let paramsNoiseCatalogNumber = new HttpParams();
    //paramsNoiseCatalogNumber = paramsNoiseCatalogNumber.append('docNumber', decodeURIComponent(findOneNoiseCatalogNumberRequest.docNumber));
    paramsNoiseCatalogNumber = paramsNoiseCatalogNumber.append('makeName', findOneNoiseCatalogNumberRequest.makeName);
    // return of(sampleNoiseCatalogParamsRefData);

    const httpOptionsParams = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      params: paramsNoiseCatalogNumber
    };
    return this.http.get<FindOneNoiseCatalogNumberResponse>(url, httpOptionsParams)
      .pipe(
        tap(data => this.findOneNoiseCatalogNumberResponse.next(data)),
        catchError(err => this.handleHttpError(err))
      );
  }

  // findAllNoiseCatalogNumberRefData(): Observable<NoiseCatalogNumberResponse | ResultStatus> {
  //   console.log('findAllNoiseCatalogNumberRefData started', Date.now.toString());
  //   const url = `noiseCatalog/findBulletinList`;
  //   // return of(sampleNoiseCatalogParamsRefData);
  //   console.log('url=' + url);
  //   return this.http.get<NoiseCatalogNumberResponse>(url, httpOptions)
  //     .pipe(
  //       tap(data => console.log('findBulletinList: ' + JSON.stringify(data))),
  //       tap(data => this.noiseCatalogNumberResponse.next(data)),
  //       catchError(err => this.handleHttpError(err))
  //     );
  // }

  // saveNewNoiseCatalog(noiseCatalogObj): Observable<any | ResultStatus> {
  //   console.log('noiseCatalogObj=', noiseCatalogObj);
  //   //const url = `${this.noiseCatalogAPIUrl}` + `/` + `tisParam/findAllNoiseCatalogParamsRefData`;
  //   const url = `noiseCatalog/saveNewNoiseCatalog`;
  //   console.log('url=', url);
  //   return this.http.post<any>(url,noiseCatalogObj, httpOptions)
  //     .pipe(
  //       tap(data => console.log('saveNewNoiseCatalog: ' + JSON.stringify(data))),
  //      // tap(data => this.noiseCatalogParamsRefDataResponse.next(data)),
  //       catchError(err => this.handleHttpError(err))
  //     );

  // }

  private handleHttpError(error: HttpErrorResponse): Observable<ResultStatus> {

    let errorStatus = new ResultStatus();
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
      // errorStatus.statusCode = error.error.
      // errorStatus.errorCode = error.statusText;
      errorStatus.errorMessage = error.error.message;
      errorStatus.errorDetails = 'An error has occurred. ' + errorStatus.errorMessage + ".";

    }
    else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
      //errorStatus.errorDetails = 'An error has occurred. ' +error.status + ' ' + error.statusText +".";
      errorStatus.errorDetails = 'Backend service is unavailable. Try again after sometime.';
      // errorStatus.errorDetails = 'Affected backend system is currently down / in maintenance mode.Error is - : ' + errorStatus.statusCode + ' (' + errorStatus.errorCode + ')';
    }
    // return an observable with a user-facing error message
    return observableThrowError(
      'Something bad happened; please try again later.');
    // return throwError(errorStatus);
    //return;
  }
}



const sampleNoiseCatalogParamsRefData =
{
  "status": {
    "statusCode": "SUCCESS"
  },
  "noiseCatalogDataParams": {
    "MINI": {
      "area": ["Body and Trim", "Infotainment", "Electrics / Electronics", "Chassis and Suspension", "Powertrain"],
      "component": ["Steering gear", "Steering column", "Stabilizer links", "Suspension links", "Struts", "Wheel bearings", "Wheels", "Brake pads", "Brake rotors", "Parking brake", "DSC", "EMF", "Window", "Glass", "Body", "Sunroof", "Door", "Seats", "Interior trim", "Dashboard", "Valve lifters", "Pistons/Rings", "Ignition", "Injectors", "Timing chain/Tensioner", "Belt drive/Pulleys/Belt tensioner", "Water pump", "Vacuum pump", "Oil pump/Chain", "Alternator", "Turbocharger/Wastegate actuators", "Crankshaft/main bearings/conrod bearings", "Crank ventilation system (TEV valve)", "Clutch/Bearing/Flywheel", "Transmission/Torque converter", "Driveshaft/Flexible discs", "Transfer case", "Differential (gears and limited slip components)", "Fuel tank/Fuel pump", "Springs and shocks", "Engine/Transmission mounts (hydraulic and vacuum)", "Shifter (mechanical)", "High Voltage Compressor", "eMachine / transmission noises (bearings)", "REx Engine / REx Generator", "Cooling Fan", "PHEV: eMachine during regeneration when HV battery is almost depleted"],
      "driveConditions": ["Cold start", "Acceleration", "Constant speed", "Braking high speed", "Braking low speed", "Turning", "Parking"],
      "weatherConditions": ["Low temperatures (below 40 F)", "High temperatures (above 40 F)", "Rain", "Snow", "Ice"],
      "kindOfNoise": ["Rattling ", "Knocking", "Grinding/Rubbing", "Squeaking / Squealing", "Whistling/Hissing", "Humming/Drone", "Howling", "Cracking / Creaking", "Clicking", "Buzzing"],
      "sporadicOrPermanent": ["SPORADIC", "PERMANENT"]
    },
    "BMW": {
      "area": ["Body and Trim", "Infotainment", "Electrics / Electronics", "Chassis and Suspension", "Powertrain"],
      "component": ["Steering gear", "Steering column", "Stabilizer links", "Suspension links", "Struts", "Wheel bearings", "Wheels", "Brake pads", "Brake rotors", "Parking brake", "DSC", "EMF", "Window", "Glass", "Body", "Sunroof", "Door", "Seats", "Interior trim", "Dashboard", "Valve lifters", "Pistons/Rings", "Ignition", "Injectors", "Timing chain/Tensioner", "Belt drive/Pulleys/Belt tensioner", "Water pump", "Vacuum pump", "Oil pump/Chain", "Alternator", "Turbocharger/Wastegate actuators", "Crankshaft/main bearings/conrod bearings", "Crank ventilation system (TEV valve)", "Clutch/Bearing/Flywheel", "Transmission/Torque converter", "Driveshaft/Flexible discs", "Transfer case", "Differential (gears and limited slip components)", "Fuel tank/Fuel pump", "Springs and shocks", "Engine/Transmission mounts (hydraulic and vacuum)", "Shifter (mechanical)", "High Voltage Compressor", "eMachine / transmission noises (bearings)", "REx Engine / REx Generator", "Cooling Fan", "PHEV: eMachine during regeneration when HV battery is almost depleted"],
      "driveConditions": ["Cold start", "Acceleration", "Constant speed", "Braking high speed", "Braking low speed", "Turning", "Parking"],
      "weatherConditions": ["Low temperatures (below 40 F)", "High temperatures (above 40 F)", "Rain", "Snow", "Ice"],
      "kindOfNoise": ["Rattling ", "Knocking", "Grinding/Rubbing", "Squeaking / Squealing", "Whistling/Hissing", "Humming/Drone", "Howling", "Cracking / Creaking", "Clicking"],
      "sporadicOrPermanent": ["SPORADIC", "PERMANENT"]
    },
    "MOTORRAD": {
      "area": ["Body and Trim", "Infotainment", "Electrics / Electronics", "Chassis and Suspension", "Powertrain"],
      "component": ["Steering gear", "Steering column", "Stabilizer links", "Suspension links", "Struts", "Wheel bearings", "Wheels", "Brake pads", "Brake rotors", "Parking brake", "DSC", "EMF", "Window", "Glass", "Body", "Sunroof", "Door", "Seats", "Interior trim", "Dashboard", "Valve lifters", "Pistons/Rings", "Ignition", "Injectors", "Timing chain/Tensioner", "Belt drive/Pulleys/Belt tensioner", "Water pump", "Vacuum pump", "Oil pump/Chain", "Alternator", "Turbocharger/Wastegate actuators", "Crankshaft/main bearings/conrod bearings", "Crank ventilation system (TEV valve)", "Clutch/Bearing/Flywheel", "Transmission/Torque converter", "Driveshaft/Flexible discs", "Transfer case", "Differential (gears and limited slip components)", "Fuel tank/Fuel pump", "Springs and shocks", "Engine/Transmission mounts (hydraulic and vacuum)", "Shifter (mechanical)", "High Voltage Compressor", "eMachine / transmission noises (bearings)", "REx Engine / REx Generator", "Cooling Fan", "PHEV: eMachine during regeneration when HV battery is almost depleted"],
      "driveConditions": ["Cold start", "Acceleration", "Constant speed", "Braking high speed", "Braking low speed", "Turning", "Parking"],
      "weatherConditions": ["Low temperatures (below 40 F)", "High temperatures (above 40 F)", "Rain", "Snow", "Ice"],
      "kindOfNoise": ["Rattling ", "Knocking", "Grinding/Rubbing", "Squeaking / Squealing", "Whistling/Hissing", "Humming/Drone", "Howling", "Cracking / Creaking", "Clicking", "Buzzing"],
      "sporadicOrPermanent": ["SPORADIC", "PERMANENT"]
    }
  }
}
